var CategoryController = function() {
    this.InfiniteScroll = require('../module/InfiniteScroll');
    this.DynamicSearch = require('../module/DynamicSearch');
    this.init();
};

CategoryController.prototype = {
    init: function() {
        //infiniteScroll & Parallax
        var infiniteScroll = new this.InfiniteScroll();
        var $window = $(window);
        var trigger;

        $('.global-header').addClass('is-search-open');

        var dynamicSearch = new this.DynamicSearch();
        dynamicSearch.init();
        dynamicSearch.setCallback(function() {
            if ($('.card').length > 0) {
                $('.search-wrapper').height('auto');
            }
            infiniteScroll.set($('.js-infinite-scroll'));
        });

        var inLoadingCallback = function() {
            if ($('.search-wrapper').length > 0) {
                var windowHeight = $(window).height();
                var wrapperHeight = $('.search-wrapper').height();

                if (windowHeight > wrapperHeight) {
                    $('.search-wrapper').height(windowHeight);
                }
            }
        }
        dynamicSearch.setInLoadingCallback(inLoadingCallback);

        var scrollHandler = function(){
            if(trigger){
                clearTimeout(trigger);
            }
            trigger = setTimeout(function(){
                if(infiniteScroll.checkPosition()){
                    infiniteScroll.load();
                }
            }, 200);
        }
        var resizeHandler = function(){
            infiniteScroll.resize();
        }
        var loadHandler = function(){
            inLoadingCallback();

            infiniteScroll.set($('.js-infinite-scroll'));
            $window.on('scroll', scrollHandler);
            $window.on('resize', resizeHandler);
        }
        $window.on('load', loadHandler);
    }
};

module.exports = CategoryController;



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/controller/SearchController.js
 **/